import React from "react";
import cmsGrayTextLogin from "../../assets/images/logo-white.png";
import ProgressSteps from "./ProgressSteps";


const SidebarLogo = () => {
    return (
      <div className="flex items-center justify-center">
        <div className="w-full max-w-[160px] h-auto flex items-center justify-center m-8">
          <img 
            src={cmsGrayTextLogin} 
            alt="ProTeams Logo" 
            className="w-full h-auto object-contain" 
          />
        </div>
      </div>
    );
  };

const AuthLayout = ({ children, sideContent, title, subtitle, register, currentStep }) => {
  return (
    <div className="flex min-h-screen bg-slate-50">
      {/* Left side - Form */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-8">
        <div className="w-full max-w-md">
          {/* Logo with shaded background */}
          <div className="flex items-center mb-88 justify-center md:justify-start bg-[#2c3440] p-4 rounded-lg">
            <SidebarLogo />
          </div>

          {/* Header */}
          <div className="mb-10">
          {register && (
            <div className="space-y-2 mb-8">
             <ProgressSteps currentStep={currentStep} totalSteps={2} />
            </div>
          )}
            <h2 className="text-3xl font-bold mv-8">{title}</h2>
            <p className="text-gray-600">
              {subtitle}
            </p>
          </div>

          {children}
        </div>
      </div>

      {/* Right side - Image/Info */}
      {sideContent && (
        <div className="hidden lg:block lg:w-1/2 bg-[#2c3440] p-50 text-white">
          {sideContent}
        </div>
      )}
    </div>
  );
};

export default AuthLayout;
